import { DASHBOARD_PATH } from '@/common/main/config';
import useAuth from '@/auth/application/useAuth';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const GuestGuard = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const inviteLinkPattern = /\/invite\/[^\/]+$/;
    const isInviteLinkUrl = inviteLinkPattern.test(location.pathname);

    if (isInviteLinkUrl) {
      return;
    }

    if (isLoggedIn) {
      navigate(`${DASHBOARD_PATH}?refreshClients=1`, { replace: true });
    }
  }, [isLoggedIn, navigate, location.pathname]);

  return children;
};

export default GuestGuard;
